import type { ApiError } from '../../common-showcase/types/showcase';

/** POST /api/eraf/catalog/module-source-bundles 성공 응답(blob) — queue #641. */
export interface ModuleSourceBundleResult {
  blob: Blob;
  filename: string;
}

function getStoredToken(): string | null {
  return localStorage.getItem('access_token') ?? sessionStorage.getItem('access_token');
}

export const gettingStartedApi = {
  /**
   * POST /api/eraf/catalog/module-source-bundles (queue #641 §R641-1)
   * body = { codes: [...] } — FE 가 이미 전이 의존(#639 take-this.json deps.codes)까지
   * union 확장한 코드집합을 그대로 전송(★BE 재확장 안 함 — §R641-2). 응답은 blob(zip) —
   * #631 exportModuleSource 와 동일하게 apiClient(axios 인터셉터) 를 우회해 raw fetch 로
   * 성공/실패를 status 로 직접 분기한다(blob 응답은 axios 오류 인터셉터를 무력화하므로).
   */
  exportModuleSourceBundle: async (codes: string[]): Promise<ModuleSourceBundleResult> => {
    const base = import.meta.env.VITE_API_BASE ?? '/api/eraf';
    const token = getStoredToken();
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${base}/catalog/module-source-bundles`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ codes }),
    });

    if (!response.ok) {
      let errCode = `HTTP-${response.status}`;
      let message = `번들 다운로드에 실패했습니다 (HTTP ${response.status})`;
      try {
        const body = (await response.json()) as { error?: { code?: string; message?: string } };
        if (body?.error?.code) errCode = body.error.code;
        if (body?.error?.message) message = body.error.message;
      } catch {
        // 응답이 JSON 이 아닌 경우(WAF/프록시 변조 등) — 기본 메시지 유지
      }
      return Promise.reject({
        code: errCode,
        message,
        statusCode: response.status,
      } as ApiError);
    }

    const disposition = response.headers.get('content-disposition') ?? '';
    const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition);
    const filename = match ? decodeURIComponent(match[1]) : `eraf-catalog-bundle-${codes.length}modules.zip`;
    const blob = await response.blob();

    return { blob, filename };
  },
};
